import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { GetLanguages, ELanguagestActions, GetLanguagesSuccess } from '../actions/languages.actiosn';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ILanguages } from 'src/app/models/languages.interface';
import { IdentifyService } from 'src/app/service/http/identify/identify.service';

@Injectable()
export class LanguagesEffects {
  
  getLanguages$ = createEffect(() => this._actions$.pipe(
    ofType<GetLanguages>(ELanguagestActions.GetLanguages),
    switchMap(() => this._identifyService.getLanguages()),
    switchMap((languages: ILanguages) => {
      return of(new GetLanguagesSuccess(languages));
    })
  ));

  constructor(
    private _identifyService: IdentifyService,
    private _actions$: Actions) {}
}
